import { render, staticRenderFns } from "./color_picker.vue?vue&type=template&id=a8d3a73e&scoped=true&"
import script from "./color_picker.vue?vue&type=script&lang=js&"
export * from "./color_picker.vue?vue&type=script&lang=js&"
import style0 from "./color_picker.vue?vue&type=style&index=0&id=a8d3a73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d3a73e",
  null
  
)

export default component.exports